import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

export class EmailInput extends Component{
	state = {
		emailVerificationSent: false
	};

	emailVerifyClick = () => {
		const {
			currentObject, handleEmailVerify
		} = this.props;

		this.setState({
			emailVerificationSent: true
		}, () => {
			handleEmailVerify(currentObject);
		})
	}

	render() {
		const {
			fieldName,
			isEditable,
			fieldType,
			currentObject,
			contactId,
			handleCloseInput,
			handleEditField,
			handleUpdate,
			inputRef,
			isDisabled,
			fieldError,
		} = this.props;

		return (
			<div className="form-group form-row">
				<div className="col-12 col-sm-3">
					{fieldType}
				</div>
				<div className="col-12 col-sm-9">
					<div className="row no-gutters verification-row">
						{isEditable !== fieldName ? (
							<>
								{currentObject && (
									<div className="col-2">
										<button
											onClick={this.emailVerifyClick}
											type="button"
											className="btn btn-xs btn-verify-value"
											disabled={this.state.emailVerificationSent || currentObject.validated}
										>
											<i className={currentObject.validated
												? "fas fa-check-circle text-success"
												: (this.state.emailVerificationSent
													? "fas fa-spin fa-circle-notch text-warning"
													: "fas fa-check text-gray-600")
											} />
										</button>
									</div>
								)}

								<div className="col-7">
									<a
										onClick={() => handleEditField(fieldName)}
										data-type="text"
										className="editable-generic-text"
									>
										{currentObject ? currentObject.email ? currentObject.email : "Not provided" : "Not provided"}
									</a>
								</div>
								<div className="input-authcode-status"></div>

								{currentObject && (
									<div className="input-group-append input-authcode-send">
										<button
											type="button"
											onClick={() => window.open(`mailto:${currentObject.email}`)}
											className="btn btn-xs btn-outline-secondary btn-authcode-send"
										>
											<i className="fas fa-envelope" /> Send
										</button>
									</div>
								)}
							</>
						) : (
							<div className="col-12">
								<div className="input-group input-group-editable w-100">
									<input
										name={fieldName}
										className="form-control"
										defaultValue={currentObject ? currentObject.email : ""}
										ref={inputRef}
										disabled={isDisabled}
										autoComplete="off"
										type="email"
									/>

									<div className="input-group-append">
										<button
											type="button"
											onClick={() => handleUpdate(fieldType, fieldName, currentObject, contactId)}
											className="btn btn-primary btn-editable-apply"
											disabled={isDisabled}
										>
											{!isDisabled ? (
												<i className="fas fa-check" />
											) : (
												<i className="fas fa-spin fa-circle-notch" />
											)}
										</button>

										{currentObject && (
											<button
												type="button"
												onClick={() => this.props.openDeleteModal(currentObject, "EMAIL")}
												className="btn btn-outline-secondary btn-editable-cancel"
												disabled={isDisabled}
											>
												{!isDisabled ? (
													<i className="fas fa-trash-alt" />
												) : (
													<i className="fas fa-spin fa-circle-notch" />
												)}
											</button>
										)}
										<button
											type="button"
											onClick={handleCloseInput}
											className="btn btn-outline-secondary btn-editable-cancel"
											disabled={isDisabled}
										>
											<i className="fas fa-times" />
										</button>
									</div>
								</div>
								{fieldError && <div className="invalid-feedback">{fieldError}</div>}
							</div>
						)}
					</div>
				</div>
			</div>


		);
	}
}

EmailInput.propTypes = {};

export default EmailInput;
